/**
 * Shown on Commissions, Payouts, and Marketing Materials when affiliate status is pending.
 * Prevents calling restricted APIs and avoids 403 being treated as session expiry.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/AffiliatePendingApproval.css';

const PendingApprovalView: React.FC<{ title?: string }> = ({
  title = 'Available after approval',
}) => (
  <div className="affiliate-pending-view" role="status" aria-live="polite">
    <div className="affiliate-pending-view__card">
      <div className="affiliate-pending-view__icon" aria-hidden>
        ⏳
      </div>
      <h2 className="affiliate-pending-view__title">{title}</h2>
      <p className="affiliate-pending-view__message">
        Your account is under review. Referral links, commissions, and payouts will be available
        once you’re approved. You’ll be notified by email when your application is processed.
      </p>
      <p className="affiliate-pending-view__hint">
        You can still update your <Link to="/affiliate/profile">Profile</Link> and read{' '}
        <Link to="/affiliate/help">Help &amp; Support</Link> in the meantime.
      </p>
      <Link to="/affiliate/dashboard" className="affiliate-pending-view__back">
        Back to Dashboard
      </Link>
    </div>
  </div>
);

export default PendingApprovalView;
